export const BET_PLACEMENT_METRIC_KEY = 'BetPlacement';
export const LEGS_PER_MULTI_METRIC_KEY = 'LegsPerMulti';
export const BET_PLACEMENT_FROM_SOURCE_SUCCESS_METRIC_KEY = 'bet-placement-from-source-success';
export const MAIN_ITEMS_LAUNCH_DARKLY_TRACKING_EVENT_KEY_COUNT = 'favorite-page-navigation-from-topnav';
export const MAIN_ITEMS_LAUNCH_DARKLY_TRACKING_EVENT_KEY_OCCURRENCE = 'favourite-page-navigation-from-topnav-occurrence';
export const RE_USE_SELECTIONS_LINK_METRIC_KEY_LIVE = 'ReuseSelectionsLinkLiveTab';
export const RE_USE_SELECTIONS_LINK_METRIC_KEY_OPEN = 'ReuseSelectionsLinkOpenTab';
export const RE_USE_SELECTIONS_LINK_METRIC_KEY_SETTLED = 'ReuseSelectionsLinkSettledTab';
export const AZ_MENU_METRIC_KEY = 'az-menu-interaction';
export const ESOCCER_METRIC_KEY = 'esoccer-item-selection';
